import illustration from '../../../../shared/assets/empty-illustration.svg'
import { Link } from 'react-router-dom'
import React from 'react'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

interface TabLookalikeDomainsProps {
  project?: string
}

export const TabLookalikeDomains = ({ project }: TabLookalikeDomainsProps) => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[24px]'}>
          <div className={'flex w-full flex-col gap-[16px]'}>
            <div className={'flex flex-col items-center'}>
              <h2 className={'text-center text-[24px]'}>No data</h2>
              <p className={'text-center text-[15px] text-[#8E7CA7]'}>Why am I seeing this?</p>
            </div>
            <div
              className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
            >
              <p className={'text-focus-500'}>
                No ads for domains incorporating your brand name found
              </p>
            </div>
          </div>
          <div className={'flex justify-center'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 A tip: go to{' '}
              <Link className={'text-default'} to={`/projects/${project}/general`}>
                project settings
              </Link>{' '}
              and make sure the brand details are accurate and up to date
            </p>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
